<template>
  <div>
    <h5>全支付說明</h5>
    <ul class="has-type-decimal">
      <li>使用全支付恕不適用分期付款。</li>
      <li>消費可使用全點折抵訂單金額。</li>
      <li>可使用全支付帳戶、連結銀行帳戶或綁定信用卡付款。</li>
      <li>於訂單成立後 20 分鐘內須完成付款。</li>
      <li>付款額度及使用限制：詳參全支付 APP > 我的 > 本月額度或常見問題</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PxPay',
};
</script>
